/** Days after which a disconnected device is hidden unless the long-disconnected toggle is on. */
export const LONG_DISCONNECTED_VISIBILITY_DAYS = 7;

/** Months after which disconnected devices can be bulk-forgotten. */
export const FORGET_OLD_DISCONNECTED_MONTHS = 6;

export const DEVICE_LIST_PATHS = {
    host: 'hosts',
    collector: 'collectors',
    printer: 'printers',
    eft: 'efts',
};
